<template>
  <div class="Content">

    <app-leftcolumn>
      <left-menu></left-menu>
    </app-leftcolumn>

    <div class="bloc-center-row">
      <app-centercolumn>
        <router-view></router-view>
      </app-centercolumn>

      <app-widgetcentercolumn>
        <meeting-view></meeting-view>
        <calendar-users></calendar-users>
      </app-widgetcentercolumn>
    </div>

    <app-rightcolumn>
      <widget-calendar></widget-calendar>
      <meeting-view></meeting-view>
      <calendar-users></calendar-users>
    </app-rightcolumn>

  </div>
</template>

<script>
  // placeholders components
  import AppLeftcolumn from 'src/components/columns/Leftcolumn.vue'
  import AppCentercolumn from 'src/components/columns/Centercolumn.vue'
  import AppWidgetcentercolumn from '../columns/WidgetCentercolumn.vue'
  import AppRightcolumn from 'src/components/columns/Rightcolumn.vue'

  import LeftMenu from 'src/components/menu/LeftMenu.vue'
  import Calendar from 'src/components/calendar/Calendar.vue'
  import MeetingView from 'src/components/widgets/MeetingView.vue'
  import WidgetCalendar from 'src/components/widgets/Calendar.vue'
  import CalendarUsers from 'src/components/widgets/Users.vue'

  export default{
    components: {
      AppLeftcolumn, AppCentercolumn, AppWidgetcentercolumn, AppRightcolumn,
      LeftMenu, Calendar, MeetingView, WidgetCalendar, CalendarUsers
    }
  }
</script>



// WEBPACK FOOTER //
// AgendaView.vue?6ca630dd